import { z, TypeOf } from 'zod';


export const ChargeSchema = z.object({
    id: z.string(),
    name: z.string(),
    product: z.string(),
    amount: z.number()
})
